import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext } from '@/common/types/navigation'

export class EvalStartNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const ticketId = this.context.id
    const params = ticketId ? `entityInstanceId=${ticketId}` : ''

    const { gridId, userId: evaluatedUserId, entityId } = action.actionData

    yield {
      ...this.getDefaultNavigationItem(action, itemContext),
      target: `/assist/quality/evaluation/new/${gridId}?ticketMode=true&evaluatedUserId=${evaluatedUserId}&entityId=${entityId}&${params}`,
    }
  }
}
